import { TranslatedString } from "@gnu-taler/taler-util";
import { VNode, h } from "preact";
import { Addon, resolveFieldHandler, UIFormProps } from "../FormProvider.js";
import { RenderAddon } from "./InputLine.js";

interface Props {
  label: TranslatedString;
  url: string;
  media?: string;
  tooltip?: TranslatedString;
  help?: TranslatedString;
  before?: Addon;
  after?: Addon;
  fileName?: string;
}

export function InputDownloadLink(props: Props & UIFormProps<boolean>): VNode {
  const {
    media,
    url,
    label,
    help,
    required,
    disabled,
    before,
    after,
    fileName,
  } = props;
  const { value, onChange, error } = resolveFieldHandler(
    props.handler,
    props.name,
  );

  return (
    <div class="col-span-6" data-downloaded={!!value}>
      {before !== undefined && <RenderAddon addon={before} />}
      <div>
        <button
          type="button"
          class="underline text-blue-600 hover:text-blue-900 visited:text-purple-600"
          aria-disabled={disabled}
          onClick={async () => {
            if (disabled) return;
            try {
              const response = await fetch(url, {
                headers: {
                  "Content-Type": media ?? "text/html",
                },
                cache: "no-cache",
              });
              if (!response.ok) throw Error(`HTTP ${response.status}`);
              const objectUrl = URL.createObjectURL(await response.blob());
              const anchor = document.createElement("a");
              anchor.href = objectUrl;
              anchor.download = fileName ?? "";
              document.body.appendChild(anchor);
              anchor.click();
              document.body.removeChild(anchor);
              URL.revokeObjectURL(objectUrl);
              // Mark the document as read only after it was fetched.
              onChange(true);
            } catch (downloadError) {
              console.error(
                "Could not download linked form document",
                downloadError,
              );
              onChange(undefined);
            }
          }}
        >
          {label}
        </button>
      </div>
      {required ? (
        <span class="text-xl bold leading-6 text-red-600 pl-2">*</span>
      ) : undefined}

      {after !== undefined && <RenderAddon addon={after} />}
      {help && (
        <p class="mt-2 text-sm text-gray-500" id="email-description">
          {help}
        </p>
      )}
      {error && <p class="mt-2 text-sm text-red-600">{error}</p>}
    </div>
  );
}
